import React from "react";

class Select extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({
      value: event.target.value,
    });

    let name = this.props.id;
    let data = event.target.value ? true : false;
    if (!data) {
      data = !this.props.required;
    }
    this.props.compStatusCheck({ [name]: data });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.value !== prevState.value && prevState.change === false) {
      return { value: nextProps.value };
    } else {
      return null;
    }
  }

  componentDidMount() {
    let name = this.props.id;
    let data = this.state.value ? true : false;
    if (!data) {
      data = !this.props.required;
    }
    this.props.compStatusCheck({ [name]: data });
  }

  render() {
    const { label, id, options, required } = this.props;
    return (
      <div className="form-group row">
        <label htmlFor={id} className="col-4 col-form-label text-right">
          {label}
        </label>
        <div className="col-8 p-0">
          <select
            className="form-control"
            id={id}
            onChange={this.handleChange}
            value={this.state.value}
            required={required}
          >
            <option></option>
            {options.map((option) => {
              return <option key={id + "-" + option}>{option}</option>;
            })}
          </select>
        </div>
      </div>
    );
  }
}

export default Select;
